import { useI18n, languages } from "@excalidraw/excalidraw/i18n";
import React from "react";

import { useSetAtom } from "../app-jotai";

// DRAWOLA:CUSTOM-START app language
import { selectAppLanguageAtom } from "./language-state";
// DRAWOLA:CUSTOM-END

export const LanguageList = ({ style }: { style?: React.CSSProperties }) => {
  const { t, langCode } = useI18n();
  // DRAWOLA:CUSTOM-START app language
  const setLangCode = useSetAtom(selectAppLanguageAtom);
  // DRAWOLA:CUSTOM-END

  return (
    <select
      className="dropdown-select dropdown-select__language"
      onChange={({ target }) => setLangCode(target.value)}
      value={langCode}
      aria-label={t("buttons.selectLanguage")}
      style={style}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
};
